import { render, staticRenderFns } from "./chat-window.vue?vue&type=template&id=1fa2a16c&scoped=true"
import script from "./chat-window.vue?vue&type=script&lang=js"
export * from "./chat-window.vue?vue&type=script&lang=js"
import style0 from "./chat-window.vue?vue&type=style&index=0&id=1fa2a16c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa2a16c",
  null
  
)

export default component.exports